import { computed, ComputedRef, ref, Ref } from "vue"
import { GridComponent as EjsGrid, PageSettingsModel, SortDescriptorModel } from '@syncfusion/ej2-vue-grids'

interface PropsUseRemoteData {
  gridRef: Ref<InstanceType<typeof EjsGrid> | null> | ComputedRef<InstanceType<typeof EjsGrid> | null>
  pageSettings: ComputedRef<PageSettingsModel>
}

interface ResponseUseRemoteData {
  pagination: Ref<Pagination>
  paginationAdapter: (args: any) => Pagination
}

type Pagination = {
  paginated: boolean
  page: number
  pageSize: number
  search?: ''
  columnOrder?: any
  filters?: any
}

export default function useRemoteData(props: PropsUseRemoteData): ResponseUseRemoteData {
  const { gridRef, pageSettings } = props

  const gridInstance = computed(() => (gridRef.value as any)?.ej2Instances)
  const defaultPagination = {
    paginated: false,
    page: pageSettings.value.currentPage,
    pageSize: pageSettings.value.pageSize
  } as Pagination
  const pagination = ref<Pagination>(defaultPagination)

  const paginationAdapter = (args: any): any => {
    const { skip = 0, take: pageSize = 10, sorted } = args
    const page = skip / pageSize + 1
    const columnOrder = getColumnOrder(sorted)
    const filters = getFilterSettings()
    const search = args.search?.[0]?.key || undefined

    pagination.value = {
      paginated: true,
      page,
      pageSize,
      ...(columnOrder !== undefined && { columnOrder }),
      ...(search !== undefined && { search }),
      ...(filters !== undefined && { filters })
    }
    return pagination.value
  }

  function getFilterSettings() {
    return gridInstance.value.filterSettings.columns.map(({ field, operator, value }: any) => {
      if (!field) {
        return
      }
      return {
        field,
        operator,
        value
      }
    })
  }

  function getColumnOrder(sorted: SortDescriptorModel[]) {
    if (!sorted) {
      return
    }
    return sorted.map(({ name: column, direction }: any) => {
      const order = direction === 'ascending' ? 'asc' : 'desc'
      return {
        order,
        column
      }
    })
  }

  return {
    pagination,
    paginationAdapter
  }
}
